import React, { useState } from 'react';

const SEVERITY_COLORS = {
  critical: { bg: 'rgba(239,68,68,0.08)', border: 'rgba(239,68,68,0.3)', text: '#EF4444', icon: '❌' },
  warning:  { bg: 'rgba(245,158,11,0.08)', border: 'rgba(245,158,11,0.3)', text: '#F59E0B', icon: '⚠️' },
  info:     { bg: 'rgba(37,99,235,0.08)',  border: 'rgba(37,99,235,0.3)',  text: '#2563EB', icon: '🔥' },
};

export default function AlertBanner({ alerts = [], onResolve }) {
  const [dismissed, setDismissed] = useState({});

  const visible = alerts.filter(a => !dismissed[a.id]);
  if (visible.length === 0) return null;

  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ fontSize: 11, fontFamily: "'JetBrains Mono', monospace", fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--muted)', marginBottom: 10 }}>
        Active Alerts
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {visible.map(alert => {
          const colors = SEVERITY_COLORS[alert.severity] || SEVERITY_COLORS.info;
          return (
            <div key={alert.id} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
              background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 10,
              padding: '12px 16px',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
                <span style={{ fontSize: 16, flexShrink: 0 }}>{colors.icon}</span>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: colors.text }}>{alert.title}</div>
                  <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{alert.message}</div>
                </div>
              </div>
              <button
                onClick={() => {
                  setDismissed(d => ({ ...d, [alert.id]: true }));
                  if (onResolve) onResolve(alert.id);
                }}
                style={{
                  background: 'transparent', border: 'none', cursor: 'pointer',
                  color: 'var(--muted)', fontSize: 16, padding: '4px 8px', flexShrink: 0,
                }}
              >×</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
